import { z } from 'zod';

import type { LogAccessProfile } from './logAccess.types';

const profileResponse = z.object({
	status: z.literal('success'),
	data: z.object({
		restricted: z.boolean(),
		mode: z.literal('namespace').optional(),
		profile: z.string().optional(),
		namespaces: z.array(z.string().min(1)).optional(),
	}),
});

export const parseLogProfile = (response: unknown): LogAccessProfile => {
	const { data } = profileResponse.parse(response);
	if (data.restricted && !data.namespaces?.length) {
		throw new Error('A restricted profile must have an allowed namespace.');
	}
	return data;
};
